module.exports = __webpack_public_path__ + "static/media/toplu-sms.19479cf1.png";